<template>
  <div>
    <vx-card>
      <vs-row vs-w="12" class="mb-5">
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-lg="1"
          vs-sm="4"
          vs-xs="12"
        >
          <vs-button
            @click="goBack"
            icon="keyboard_backspace"
            >Back</vs-button
          >
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-lg="9"
          vs-sm="4"
          vs-xs="12"
        >
          <h3>Account/Contact List of Campaign</h3>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-lg="2"
          vs-sm="4"
          vs-xs="12"
        >
        </vs-col>
      </vs-row>

      <div class="demo-alignment">
        <vs-popup
          title="Choose the options to enrich data to campaign."
          :active.sync="popupActive"
        >
          <div class="text-center">
                   <vs-button
       class="mr-4 ml-4"
            color="danger"
            @click="addContactsToExistingCampaignAccounts"
            type="filled"
            >Add contacts to existing campaign accounts</vs-button
          >
                 <vs-button
       class="mr-4 ml-4"
            color="danger"
            @click="addNewAccountsContactsToCampaign"
            type="filled"
            >Add new accounts/contacts to the campaign</vs-button
          >
                 <vs-button
       class="mr-4 ml-4"
            color="danger"
            @click="enrichAccountContactsWithAdvancedCriteria"
            type="filled"
            >Add new accounts/contacts with advanced criteria</vs-button
          >
       <!-- <vs-button
       class="mr-4 ml-4"
            color="danger"
            @click="addNewAccountsContactsToCampaign"
            type="filled"
            >Enrich Individually</vs-button
          >
          <vs-button
                 class="mr-4 ml-4"

            color="danger"
            @click="enrichAccountContactsColletively"
            type="filled"
            >Enrich Collectively</vs-button
          >   -->
          </div>
             
        </vs-popup>
      </div>

      <vs-table class="mb-10" stripe :data="records">
        <template slot="thead">
          <vs-th sort-key="s_no">S No.</vs-th>
          <vs-th sort-key="Steps">Campaign</vs-th>
          <vs-th sort-key="Steps_description">Actions</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="data[indextr]">
              {{ indextr + 1 }}
            </vs-td>
            <vs-td :data="data[indextr].campaign_name">
              {{ data[indextr].campaign_name }}
            </vs-td>
            <vs-td>
              <vs-button
                @click="showMatchedAccounts(data[indextr])"
                class="mr-5"
                >View</vs-button
              >
              <vs-button
                @click="chooseEnrichTypes(data[indextr].campaign_id)"
                >Enrich</vs-button
              >
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vx-card>
  </div>
</template>

<script>
var Base64={_keyStr:"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",encode:function(e){var t="";var n,r,i,s,o,u,a;var f=0;e=Base64._utf8_encode(e);while(f<e.length){n=e.charCodeAt(f++);r=e.charCodeAt(f++);i=e.charCodeAt(f++);s=n>>2;o=(n&3)<<4|r>>4;u=(r&15)<<2|i>>6;a=i&63;if(isNaN(r)){u=a=64}else if(isNaN(i)){a=64}t=t+this._keyStr.charAt(s)+this._keyStr.charAt(o)+this._keyStr.charAt(u)+this._keyStr.charAt(a)}return t},decode:function(e){var t="";var n,r,i;var s,o,u,a;var f=0;e=e.replace(/[^A-Za-z0-9\+\/\=]/g,"");while(f<e.length){s=this._keyStr.indexOf(e.charAt(f++));o=this._keyStr.indexOf(e.charAt(f++));u=this._keyStr.indexOf(e.charAt(f++));a=this._keyStr.indexOf(e.charAt(f++));n=s<<2|o>>4;r=(o&15)<<4|u>>2;i=(u&3)<<6|a;t=t+String.fromCharCode(n);if(u!=64){t=t+String.fromCharCode(r)}if(a!=64){t=t+String.fromCharCode(i)}}t=Base64._utf8_decode(t);return t},_utf8_encode:function(e){e=e.replace(/\r\n/g,"\n");var t="";for(var n=0;n<e.length;n++){var r=e.charCodeAt(n);if(r<128){t+=String.fromCharCode(r)}else if(r>127&&r<2048){t+=String.fromCharCode(r>>6|192);t+=String.fromCharCode(r&63|128)}else{t+=String.fromCharCode(r>>12|224);t+=String.fromCharCode(r>>6&63|128);t+=String.fromCharCode(r&63|128)}}return t},_utf8_decode:function(e){var t="";var n=0;var r=c1=c2=0;while(n<e.length){r=e.charCodeAt(n);if(r<128){t+=String.fromCharCode(r);n++}else if(r>191&&r<224){c2=e.charCodeAt(n+1);t+=String.fromCharCode((r&31)<<6|c2&63);n+=2}else{c2=e.charCodeAt(n+1);c3=e.charCodeAt(n+2);t+=String.fromCharCode((r&15)<<12|(c2&63)<<6|c3&63);n+=3}}return t}}
import defineAbilitiesFor from "@/config/abilities";
import axios from "@/axios.js";
import moduleCampaignsManagement from "@/store/campaign-management/moduleCampaignManagement.js";
import JsonExcel from "vue-json-excel";

export default {
  components: {
    downloadExcel: JsonExcel
  },
  data() {
    return {
      selected_campaign_id: null,
      popupActive: false,
      json_fields: {
        Company: "ml_company",
        Address: "ml_addresses"
      },
      campaignName: null,
      abilities: null,
      records: [],
    enrich_none_core_number_type_ids : [],
      campaign_account_none_core_field_columns: '',
    campaign_account_none_core_field_ids: '',
    campaign_contact_none_core_field_columns: '',
    campaign_contact_none_core_field_ids: ''
    };
  },
  computed: {},
  methods: {

    getAllAccountSelectedCampaignColumns(campaign) {
      var self = this;
      self.$store
        .dispatch(
          "campaignsManagement/getAllAccountSelectedCampaignColumns",
          campaign.campaign_id
        )
        .then(res => {
            let selected_columns = JSON.parse(res.data);



              selected_columns = selected_columns.filter(function(ele) {
                return ele.identifier != 'phone_code' && ele.identifier != 'phone_type' && ele.identifier != 'switchboard_phone_code' 
              });


              var index = 1;
            selected_columns.forEach(function(ele) {
              ele.id = ele.uuid
          
              ele.headerName = ele.name;

              if (ele.identifier == 'none_core_field') {
                ele.field = '_' + ele.id.replaceAll("-", "_");

                if (ele.type == "textarea") {
                ele.cellRenderer =  function(params) {
                            return params.value ? params.value : '';
                        }
              }

                if (ele.type == 'number'){
                  self.enrich_none_core_number_type_ids.push(ele.field)
                }


                let ele_with_t = 'acc' + index + '.' + ele.field;
                self.campaign_account_none_core_field_columns = self.campaign_account_none_core_field_columns + ',' + ele.id;
                self.campaign_account_none_core_field_ids = self.campaign_account_none_core_field_ids + ',' + ele_with_t;
                index += 1;

                }else{
                  ele.field = ele.identifier;
                }


                if (ele.type == "date" || ele.type == "datetime") {
                    ele.filter = "agDateColumnFilter";
                } else if (ele.type == "number") {
                  ele.filter = "agNumberColumnFilter";
                } else {
                  ele.filter = "agTextColumnFilter";
                }



              ele.width = 170;
              ele.filterParams = {
                buttons: ["apply", "reset"],
                maxNumConditions: 4
              };
            });


          self.accountColumnDefs = selected_columns

          localStorage.setItem("campaign_account_none_core_field_columns", self.campaign_account_none_core_field_columns);
          localStorage.setItem("campaign_account_none_core_field_ids", self.campaign_account_none_core_field_ids);
          localStorage.setItem("enrich_none_core_number_type_ids", self.enrich_none_core_number_type_ids);


          self.getAllContactSelectedCampaignColumns(campaign)


          

        

        })
        .catch(err => {
          console.log(err);
        });
    },
    getAllContactSelectedCampaignColumns(campaign) {
    var self = this;
    self.$store
      .dispatch(
        "campaignsManagement/getAllContactSelectedCampaignColumns",
        campaign.campaign_id
      )
      .then(res => {
            let selected_columns = JSON.parse(res.data);


            selected_columns = selected_columns.filter(function(ele) {
              return ele.identifier != 'mobile_phone_code' && ele.identifier != 'ddi_phone_code' 
            });

            var index = 1;
            selected_columns.forEach(function(ele) {
              ele.id = ele.uuid

          
              ele.headerName = ele.name;

              if (ele.identifier == 'none_core_field') {
                ele.field = '_' + ele.id.replaceAll("-", "_");

                if (ele.type == "textarea") {
                ele.cellRenderer =  function(params) {
                            return params.value ? params.value : '';
                        }
              }

                if (ele.type == 'number'){
                  self.enrich_none_core_number_type_ids.push(ele.field)
                }

                let ele_with_t = 'con' + index + '.' + ele.field;
                self.campaign_contact_none_core_field_columns = self.campaign_contact_none_core_field_columns + ',' + ele.id;
                self.campaign_contact_none_core_field_ids = self.campaign_contact_none_core_field_ids + ',' + ele_with_t;
                index += 1;

                }else{
                  ele.field = ele.identifier;
                }


                if (ele.type == "date" || ele.type == "datetime") {
                  ele.filter = "agDateColumnFilter";
                } else if (ele.type == "number") {
                  ele.filter = "agNumberColumnFilter";
                } else {
                  ele.filter = "agTextColumnFilter";
                }



              ele.width = 170;
              ele.filterParams = {
                buttons: ["apply", "reset"],
                maxNumConditions: 4
              };
            });


          self.contactColumnDefs = selected_columns

          localStorage.setItem("campaign_contact_none_core_field_columns", self.campaign_contact_none_core_field_columns);
          localStorage.setItem("campaign_contact_none_core_field_ids", self.campaign_contact_none_core_field_ids);

          localStorage.setItem("enrich_none_core_number_type_ids", self.enrich_none_core_number_type_ids);

      
          self.$router.push("/accounts/matched/" + campaign.campaign_id + '/' + btoa(campaign.campaign_name));
          self.$vs.loading.close();
      

      })
      .catch(err => {
        console.log(err);
      });
  },




 
    showMatchedAccounts: function(campaign) {

      this.$vs.loading();


      this.getAllAccountSelectedCampaignColumns(campaign)





    },
    chooseEnrichTypes: function(campaign_id) {
      this.selected_campaign_id = campaign_id;
      this.popupActive = true;
    },
    addContactsToExistingCampaignAccounts: function() {
      this.$router.replace(
        {
          name: "select-filter-for-enrich-account-data",

          // name: "add-contacts-to-existing-campaign-accounts",
          params: { campaignId: this.selected_campaign_id }
        },
        () => {
          this.$router.go(0);
        })
    },
    addNewAccountsContactsToCampaign: function() {
      this.$router.replace(
        {
          // name: "add-new-accounts-contacts-to-campaign",
          name: "select-filter-for-enrich-new-account-data",
          params: { campaignId: this.selected_campaign_id }
        },
        () => {
          this.$router.go(0);
        })
    },
    enrichAccountContactsWithAdvancedCriteria: function() {
      this.$router.replace(
        {
          name: "select-filter-for-enrich-data",
          params: { campaignId: this.selected_campaign_id }
        },
        () => {
          this.$router.go(0);
        })
    },
    goBack: function() {
      this.$router.go(-1);
    },
    getCampaigns() {
      axios
        .get(
          this.$base_url + "/api/unmatched_accounts/get_unmatched_campaign_list"
        )
        .then(response => {
          this.records = response.data;

          if (this.records.length != 0) {
            this.records.forEach(function(record) {
              record.campaign_id = record.id
            });
          }


        })
        .catch(error => {
          console.log(error);
        });
    }
  },
  mounted() {
    this.getCampaigns();
  },
  created() {
    var self = this;
    defineAbilitiesFor().then(function(data) {
      self.abilities = data;
    });
    if (!moduleCampaignsManagement.isRegistered) {
      this.$store.registerModule(
        "campaignsManagement",
        moduleCampaignsManagement
      );
      moduleCampaignsManagement.isRegistered = true;
    }
    this.campaignName = this.$route.params.campaignName;
  }
};
</script>
<style>
.vs-popup{
  width: auto !important;
}
</style>
